import React from 'react'
import { Layout } from './Layout';
function Home() {
  return (
    <Layout>
    <h2>Home page</h2>
    </Layout>
  )
}
export default Home;
